import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { FloorResponse } from '@command-floor/shared-types';
import { api } from '../lib/api.js';
import { FloorView } from '../features/floor/FloorView.js';
import { CreateTableButton } from '../features/floor/CreateTableButton.js';
import { useCanCreateTable } from '../lib/auth.js';

export function FloorPage() {
  const canCreate = useCanCreateTable();
  const [createOpen, setCreateOpen] = useState(false);

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['floor'],
    queryFn: () => api.get<FloorResponse>('/api/floor'),
  });

  return (
    <div className="relative h-full">
      {isLoading && (
        <div className="flex h-full items-center justify-center text-slate-500">Loading floor…</div>
      )}
      {error && (
        <div className="flex h-full items-center justify-center text-slate-300">
          <div className="text-center">
            <p className="text-lg font-medium">Could not load the floor</p>
            <p className="mt-1 text-sm text-slate-500">{(error as Error).message}</p>
          </div>
        </div>
      )}
      {data && <FloorView data={data} />}

      {canCreate && (
        <button
          onClick={() => setCreateOpen(true)}
          className="absolute bottom-6 right-6 rounded-full bg-flag-blue px-5 py-3 text-sm font-medium text-white shadow-lg hover:bg-blue-600"
        >
          + New table
        </button>
      )}

      {createOpen && (
        <CreateTableButton
          onClose={() => {
            setCreateOpen(false);
            void refetch();
          }}
        />
      )}
    </div>
  );
}
